import styled from "styled-components";
import { Button as MauiButton, constants, Modal, Text } from "@findemdev/maui";

const { colors, dimensions } = constants;

const MODAL_HORIZONTAL_PADDING = dimensions.spacing["3"];
const MODAL_VERTICAL_PADDING = `calc(${dimensions.spacing["2"]} + ${dimensions["border-radius"].xs})`;
const MODAL_CLOSE_SIZE = dimensions.spacing["3"];
const CONTROL_HORIZONTAL_PADDING = `calc(${dimensions.spacing["1"]} + ${dimensions["border-radius"].xs})`;

export const UploadModalFrame = styled(Modal)`
  .ant-modal-content {
    background-color: ${colors.white};
    border-radius: ${dimensions["border-radius"].lg};
    overflow: hidden;
    padding: 0;
  }

  .ant-modal-header {
    background-color: ${colors.white};
    margin: 0;
    padding: ${MODAL_VERTICAL_PADDING} ${MODAL_HORIZONTAL_PADDING};
  }

  .ant-modal-title {
    color: ${colors.black};
  }

  .ant-modal-close {
    color: ${colors["grey-500"]};
    height: ${MODAL_CLOSE_SIZE};
    right: ${MODAL_HORIZONTAL_PADDING};
    top: ${MODAL_VERTICAL_PADDING};
    width: ${MODAL_CLOSE_SIZE};
  }

  .ant-modal-close-x {
    align-items: center;
    display: flex;
    height: ${MODAL_CLOSE_SIZE};
    justify-content: center;
    line-height: ${MODAL_CLOSE_SIZE};
    width: ${MODAL_CLOSE_SIZE};
  }

  .ant-modal-body {
    padding: ${dimensions.spacing["3"]} ${MODAL_HORIZONTAL_PADDING} 0;
  }

  .ant-modal-footer {
    border-top: 1px solid ${colors["grey-200"]};
    margin: 0;
    padding: ${dimensions.spacing["2"]} ${MODAL_HORIZONTAL_PADDING}
      ${MODAL_VERTICAL_PADDING};
  }
`;

export const UploadModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${dimensions.spacing["2"]};
`;

export const CurrentFileInfo = styled.div`
  background-color: ${colors["grey-100"]};
  border: 1px solid ${colors["grey-300"]};
  border-radius: ${dimensions["border-radius"].md};
  display: flex;
  flex-direction: column;
  gap: ${dimensions["border-radius"].sm};
  padding: ${dimensions.spacing["1"]} ${CONTROL_HORIZONTAL_PADDING};
`;

export const CurrentFileLabel = styled(Text).attrs({
  as: "span",
  variant: "detail",
})`
  color: ${colors["grey-500"]};
`;

export const CurrentFileName = styled(Text).attrs({ as: "span" })`
  color: ${colors["grey-700"]};
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ErrorText = styled(Text).attrs({ as: "p" })`
  color: ${colors["red-400"]};
  margin: 0;
`;

export const BehaviourSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${dimensions["border-radius"].sm};
`;

export const BehaviourTextarea = styled.textarea`
  border: 1px solid ${colors["grey-300"]};
  border-radius: ${dimensions["border-radius"].md};
  color: ${colors["grey-700"]};
  font-family: inherit;
  font-size: 13px;
  line-height: 1.4;
  min-height: 72px;
  padding: ${dimensions["border-radius"].sm} ${CONTROL_HORIZONTAL_PADDING};
  resize: vertical;
  width: 100%;

  &::placeholder {
    color: ${colors["grey-400"]};
  }

  &:focus {
    border-color: ${colors["blue-300"]};
    outline: none;
  }

  &:disabled {
    background-color: ${colors["grey-100"]};
    color: ${colors["grey-400"]};
    cursor: default;
  }
`;

export const UploadModalFooter = styled.div`
  display: flex;
  gap: ${dimensions.spacing["1"]};
  justify-content: flex-end;
`;

export const CancelButton = styled(MauiButton)`
  && {
    align-items: center;
    background-color: ${colors.white} !important;
    border: 1px solid ${colors["grey-400"]} !important;
    border-radius: ${dimensions["border-radius"].md};
    box-shadow: none;
    color: ${colors["grey-700"]} !important;
    display: inline-flex;
    height: ${dimensions.height.md};
    justify-content: center;
    padding: 0 ${CONTROL_HORIZONTAL_PADDING};
    text-shadow: none;
  }

  &&:hover,
  &&:focus {
    background-color: ${colors.white} !important;
    border-color: ${colors["grey-400"]} !important;
    color: ${colors["grey-700"]} !important;
  }
`;

export const DownloadButton = styled(MauiButton)`
  && {
    align-items: center;
    background-color: ${colors.white} !important;
    border: 1px solid ${colors["grey-400"]} !important;
    border-radius: ${dimensions["border-radius"].md};
    box-shadow: none;
    color: ${colors["grey-700"]} !important;
    display: inline-flex;
    gap: ${dimensions["border-radius"].sm};
    height: ${dimensions.height.md};
    justify-content: center;
    padding: 0 ${CONTROL_HORIZONTAL_PADDING};
    text-shadow: none;
  }

  &&:hover,
  &&:focus {
    background-color: ${colors["grey-100"]} !important;
    border-color: ${colors["grey-400"]} !important;
    color: ${colors["grey-700"]} !important;
  }

  &&:disabled {
    opacity: 0.45;
  }
`;

export const UploadButton = styled(MauiButton)`
  && {
    align-items: center;
    background-color: ${colors["blue-300"]} !important;
    border: 1px solid ${colors["blue-300"]} !important;
    border-radius: ${dimensions["border-radius"].md};
    box-shadow: none;
    color: ${colors.white} !important;
    display: inline-flex;
    height: ${dimensions.height.md};
    justify-content: center;
    padding: 0 ${CONTROL_HORIZONTAL_PADDING};
    text-shadow: none;
  }

  &&:hover,
  &&:focus {
    background-color: ${colors["blue-300"]} !important;
    border-color: ${colors["blue-300"]} !important;
    color: ${colors.white} !important;
  }

  &&:disabled {
    opacity: 0.45;
  }
`;
